export enum VisitScheduleStatusEnum {
  Init = "Init",
  Ongoing = "Ongoing",
  Processing = "Processing",
  Completed = "Completed",
}


